/**
 * The emoji people can pick as a picture, and the ones they can react with.
 *
 * Shared rather than kept in the client because the server validates against
 * the reaction list, and two copies of a list like this drift the first time
 * somebody adds a face to one of them.
 *
 * Grouped, because a flat grid of sixty emoji is a wall. The groups are how
 * somebody actually looks for one: an animal, a face, a thing, a mood.
 */
export const AVATAR_GROUPS = [
    {
        label: 'Animals',
        emoji: [
            '🐏', '🐐', '🦊', '🐸', '🦉', '🐙', '🦈', '🐺',
            '🦝', '🐲', '🦩', '🦎', '🐧', '🦇', '🐝', '🦂',
            '🐌', '🦕', '🐿️', '🦦',
        ],
    },
    {
        label: 'Faces',
        emoji: [
            '👾', '🤖', '👽', '🤠', '🥸', '🤡', '😈', '💀',
            '🫠', '🧐', '🤨', '😎', '🤓', '🥶', '🫥', '🗿',
        ],
    },
    {
        label: 'Sound',
        emoji: [
            '🎧', '🎸', '🎺', '🥁', '🎹', '🎤', '📻', '💿',
            '📼', '🔊', '🎷', '🪕',
        ],
    },
    {
        label: 'Things',
        emoji: [
            '🔥', '⚡', '🪐', '🧊', '🍕', '🌵', '🕹️', '🎲',
            '🧿', '🪩', '🛸', '⚓', '🪓', '🧲', '🔮', '🚬',
            '🛞', '🧻', '🪟', '🗡️',
        ],
    },
];
/** Every avatar emoji, flat — for validation and for a simple grid. */
export const AVATAR_EMOJI = AVATAR_GROUPS.flatMap((group) => group.emoji);
/** What a member starts with before they pick. The club animal. */
export const DEFAULT_AVATAR = '🐏';
//# sourceMappingURL=avatars.js.map